import React, { useCallback, useContext } from 'react';
import { ModalToConfirm } from 'components/ModalWindows/ModalToConfirm';
import ModalSentSuccessfully from 'components/ModalWindows/ModalSentSuccessfully';
import ModalSentError from 'components/ModalWindows/ModalSentError';
import { useHistory } from 'react-router-dom';
import { AppContext, IAppContext } from 'appState/appContext';
import { convertUndefinedFields } from 'utils/helpers';
import { CREATE_REPORT } from '../../../../reportsContainerState/reportsContainerContext';
import { IReportsContext, ReportsContext } from '../../reportsContext/reportsState/reportsContext';
import { createRestaurantReports, updateRestaurantReports } from 'backend/restaurants';
import classNames from 'classnames';
import style from './ModalWindows.module.scss';

const ModalWindows: React.FC = () => {
	const { showLoader, hideLoader } = useContext<IAppContext>(AppContext);
	const { setHasBanOnChanges, changeTypeOfModalWindow, dataForSubmit, typeOfModalWindow } =
		useContext<IReportsContext>(ReportsContext);
	const history = useHistory();
	const containerClasses = classNames(style.container, { [style.visible]: typeOfModalWindow });

	const handleRedirect = useCallback(() => {
		history.push('/clients/restaurants');
	}, [history]);

	const handleSubmitWatchesInfo = useCallback(async () => {
		if (dataForSubmit) {
			try {
				const convertedData = convertUndefinedFields(dataForSubmit);
				showLoader();
				if (convertedData.id === CREATE_REPORT) {
					await createRestaurantReports({
						restaurantId: convertedData.restaurantId,
						reportType: convertedData.reportType,
						scheduleTypes: convertedData.scheduleTypes,
						emails: convertedData.emails,
						copyEmails: convertedData.copyEmails,
						isShiftsWorking: convertedData.isShiftsWorking,
					});
					setHasBanOnChanges();
				} else {
					await updateRestaurantReports({
						id: convertedData.id,
						scheduleTypes: convertedData.scheduleTypes,
						emails: convertedData.emails,
						copyEmails: convertedData.copyEmails,
						isShiftsWorking: convertedData.isShiftsWorking,
					});
				}
				changeTypeOfModalWindow('success');
			} catch (err) {
				changeTypeOfModalWindow('error');
			} finally {
				hideLoader();
			}
		}
	}, [dataForSubmit]);

	const handleCloseModal = useCallback(() => {
		changeTypeOfModalWindow(null);
	}, []);

	return (
		<div className={containerClasses} data-test="ModalWindows">
			<ModalToConfirm
				onConsentEvent={handleRedirect}
				onFailureEvent={handleCloseModal}
				isVisible={typeOfModalWindow === 'toConfirmFieldsClearing'}
				description="cancelSaveInfo"
			/>
			<ModalToConfirm
				onConsentEvent={handleSubmitWatchesInfo}
				onFailureEvent={handleCloseModal}
				isVisible={typeOfModalWindow === 'toConfirmSubmit'}
				description="saveInfo"
			/>
			<ModalSentSuccessfully
				onConsentEvent={handleCloseModal}
				isVisible={typeOfModalWindow === 'success'}
				description="savedSuccessfully"
			/>
			<ModalSentError
				onConsentEvent={handleCloseModal}
				isVisible={typeOfModalWindow === 'error'}
				description="errorWhileSaving"
			/>
		</div>
	);
};

export default ModalWindows;
